import 'apps/hiring/styles/components/opening-invite.scss';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import Modal from 'library/components/modal';
import PlusSvg from 'library/icons/plus.svg';
import { ShimmyZone } from 'library/components/shimmy';
import InviteApplicants from 'apps/hiring/components/invite-applicants';
import InviteEmployees from 'apps/hiring/components/invite-employees';

class OpeningInvite extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['employee','opening'])
  }

  static defaultProps = {
    type: 'applicant'
  }

  state = {
    active: false,
    path: '/',
    edit: false
  }

  handlePathChange = (path) => {
    this.setState({
      path: path
    });
  }

  handleChange = ({ target }) => {
    const { name, value } = target;

    this.setState({
      [name]: value
    });
  }


  activateModal = () => {
    this.setState({
      active: true
    });
  }

  deactivateModal = () => {
    this.setState({
      active: false,
      edit: false
    });

  }

  toggleEdit = () => {
    this.setState({
      edit: !this.state.edit
    });
  }

  render() {
    const {
      opening,
      type='opening'
    } = this.props;

    const {
      edit
    } = this.state;

    return (
      <Fragment>
        <button disabled={resolve(opening, 'closed', false)===true} onClick={this.activateModal}>Invite <PlusSvg /></button>
        <Modal onClose={this.deactivateModal} active={this.state.active}>
          <div className={['hiring-modal', this.state.path.replace(/^\//, ''), edit ? 'edit': null ].filter(c=>c).join(' ')}>
            <div className={['hiring-modal-header', edit ? 'edit': null].filter(c=>c).join(' ')}>
              <div className="hiring-modal-header-inner">
                <ShimmyZone namespace="hiring-modal-header-invite">
                  <p key="invite-title">INVITE APPLICANTS</p>
                </ShimmyZone>
                <a onClick={this.deactivateModal} href="javascript:void(0)">×</a>
              </div>
              <svg className="hiring-modal-header-svg" width="100%" height="20px" viewBox="0 0 100 50" preserveAspectRatio="none">
                <path className="hiring-modal-header-svg-first" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 100,50 0,0`}></path>
                <path className="hiring-modal-header-svg-second" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 0,50 0,0`}></path>
              </svg>
            </div>
            <div className="hiring-modal-body">
              {
                type==='opening'
                  ? (
                    <InviteApplicants
                      closeModal={this.deactivateModal}
                      openingId={resolve(opening, 'id', '')}
                      disabled={resolve(opening, 'closed', false)===true}
                      token={resolve(opening, 'settings/invitation_token', '')}
                      toggleEdit={this.toggleEdit}
                    />
                  )
                  : (
                    <InviteEmployees
                      closeModal={this.deactivateModal}
                      toggleEdit={this.toggleEdit}
                    />
                  )
              }
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default OpeningInvite;
